// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "./Layer";

export default function Associates() {
	const Icon = getOutlinedPositionIcon({ position: "Sales Associate" });
	return (
		<PageLayer title={"Sales Associates Pay Plans"} icon={Icon}>
			<Layer />
		</PageLayer>
	);
}
